module.exports = __webpack_public_path__ + "img/reminder.e0dcc773.svg";